import { createFileRoute } from "@tanstack/react-router";
import { AiToolEditor } from "@/components/admin/ai-tools/ai-tool-editor";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/settings/ai-tools/$toolId")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminAiToolPage,
});

function AdminAiToolPage() {
  const { toolId } = Route.useParams();
  return <AiToolEditor toolId={toolId} />;
}
